<div class="container mx-auto">
  <section class="pb-5">
    <div class="banner">
      <div class="relative mt-3">
        <ng-container *ngIf="isLoading; else bannerTemplate">
          <div class="skeleton h-96 w-full "></div>
        </ng-container>
        <ng-template #bannerTemplate>
          <div class="video-wrapper" *ngIf="safeYoutubeUrl">
            <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315" [src]="safeYoutubeUrl"
              frameborder="0" allowfullscreen></iframe>
          </div>
          <div *ngIf="!safeYoutubeUrl" class="bg-cover rounded-[40px] pt-4">
            <img loading="lazy" class="w-full rounded-[16px] lg:rounded-[40px] backdrop-blur-3xl  object-contain"
              src="assets/images/banner/banner-transcend.png" alt="{{eventDetail?.title}}" (error)="onError($event)">
          </div>
        </ng-template>
      </div>
    </div>
  </section>
</div>
<div class="container px-2 mx-auto">
  <ng-container *ngIf="isLoading; else content">
    <div class="flex flex-col gap-2 w-2/4 my-10">
      <div class="skeleton h-4 w-20"></div>
      <div class="skeleton h-4 w-4/5"></div>
      <div class="skeleton h-4 w-3/5"></div>
      <div class="skeleton h-4 w-full mt-3"></div>
      <div class="skeleton h-4 w-4/5"></div>
      <div class="skeleton h-4 w-3/5"></div>
      <div class="flex gap-4 items-center">
        <div class="skeleton w-16 h-16 rounded-full shrink-0"></div>
        <div class="flex flex-col gap-4">
          <div class="skeleton h-4 w-20"></div>
          <div class="skeleton h-4 w-28"></div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #content>
    <section>
      <div class="grid grid-cols-1  gap-x-10 py-10 pb-2 relative" [ngClass]="{
    'grid-cols-1': isEventEnd && eventDetail?.status !== 'up_coming' || eventDetail?.status !== 'ongoing',
    'md:grid-cols-2': !isEventEnd && eventDetail?.status === 'up_coming'}">
        <div class="event-detail-wrp">
          <div class="event-detail-wrap prose w-full"
            [ngClass]="{'max-w-full': isEventEnd && eventDetail?.status !== 'up_coming' || eventDetail?.status === 'ongoing'}">
            <div *ngIf="eventDetail?.status === 'up_coming'" class=" badge text-[10px] mb-2 uppercase rounded shadow-md"
              [ngClass]="{ 'bg-gradient-to-r from-pink-500 to-red-600 border-[#ff0a4c] text-slate-50': eventDetail?.status === 'up_coming'}">
              Upcoming
            </div>
            <div *ngIf="eventDetail?.status === 'ongoing'"
              class="badge text-[10px] uppercase rounded bg-[#d80a0a] border-[#d80a0a] shadow-md text-slate-50"><img
                class="w-4 rotate" src="assets/images/live-icon.png" alt="">
              <span class="ml-1">LIVE</span>
            </div>
            <h2 class="mt-0 mb-0 leading-8">{{eventDetail?.title}}</h2>
            <small [ngClass]="currentTheme === 'dark' ? 'text-gray-300' : 'text-black'" *ngIf="eventDetail?.start_time"
              class="block text-sm mt-1"><span class="text-gray-400">On:
              </span>{{eventDetail?.start_time | date:'EEE dd MMM, yyyy hh:mm a'}}</small>
            <p class="not-prose mt-4 event-desc" *ngIf="eventDetail?.description"
              [innerHTML]="eventDetail?.description">
            </p>
            <p class="font-medium mb-0" *ngIf="eventDetail?.start_time">
              on {{eventDetail?.start_time | date:'EEE dd MMM, yyyy'}}
            </p>
            <p class="font-medium mb-2 mt-1" *ngIf="eventDetail?.start_time">Time: {{eventDetail?.start_time |
              date:'hh:mm a'}} to {{eventDetail?.end_time | date:'hh:mm a'}}</p>
            <div class="addreswrap [&>p]:my-0"
              *ngIf="eventDetail?.location || eventDetail?.address_1 || eventDetail?.address_2 || eventDetail?.city">
              <h5 class="font-bold text-lg border-b inline-block mb-2">Location</h5>
              <p class="font-semibold" *ngIf="eventDetail?.location">{{eventDetail?.location}}</p>
              <p *ngIf="eventDetail?.address_1">{{eventDetail?.address_1}}</p>
              <p *ngIf="eventDetail?.address_2">{{eventDetail?.address_2}}</p>
              <p *ngIf="eventDetail?.city">{{eventDetail?.city}}</p>
            </div>
          </div>
          <ng-container
            *ngIf="eventDetail?.speakers && eventDetail.speakers.length > 0">
            <div class="grid gap-3 grid-cols-1" [ngClass]="{'grid-cols-1 md:grid-cols-2': eventDetail.speakers.length > 1}">
              <div class="speaker-wrap mb-4" *ngFor="let speaker of eventDetail.speakers.slice().reverse()">
                <div class="avatar border-[3px] mb-2 rounded-full p-1">
                  <div class="w-24 rounded-full" *ngIf="speaker?.profile_image">
                    <img [src]="speaker?.profile_image" [alt]="speaker?.name" />
                  </div>
                  <div *ngIf="!speaker?.profile_image" class="w-16 h-16 lg:w-20 lg:h-20 lg:text-3xl rounded-full bg-primary
                    text-slate-50 !flex justify-center items-center text-2xl font-semibold uppercase">
                    {{speaker?.name | slice: 0 : 1}}
                  </div>
                </div>
                <div class="speakerinf mb-5 leading-tight">
                  <h4 class="font-semibold capitalize" *ngIf="speaker?.name">{{speaker?.name}}</h4>
                  <p *ngIf="speaker?.job_title" class="capitalize"><small>{{speaker?.job_title}}</small></p>
                  <p *ngIf="speaker?.company_name" class="capitalize font-bold"><small>{{speaker?.company_name}}</small>
                  </p>
                  <p *ngIf="speaker?.description" class="italic text-slate-500 text-xs mt-2">{{speaker?.description}}
                  </p>
                  <p class="flex gap-4 mt-2 group [&_a]:text-slate-500 hover:[&_a]:text-primary
                                      [&_a]:transition [&_a]:duration-150">
                    <a *ngIf="speaker?.facebook_url" target="_blank" href="{{speaker?.facebook_url || '#'}}">
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a *ngIf="speaker?.twitter_url" target="_blank" href="{{speaker?.twitter_url || '#'}}">
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a *ngIf="speaker?.linkedIn_url" target="_blank" href="{{speaker?.linkedIn_url || '#'}}">
                      <i class="fab fa-linkedin-in"></i>
                    </a>
                    <a *ngIf="speaker?.mail" target="_blank" href="mailto:{{speaker?.mail || '#'}}">
                      <i class="fas fa-paper-plane"></i>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
        <div>
          <div *ngIf="eventDetail?.status === 'up_coming'">
            <div class="register-form max-w-xl mx-auto border fixed max-md:bottom-0 max-md:bg-white max-md:w-full max-md:left-0 z-10 md:mb-4 px-6 md:sticky md:top-5 py-3">
              <!-- <h3 class="text-center text-lg md:text-xl font-semibold md:mb-3 pb-2 md:py-3">REQUEST AN EXCLUSIVE INVITATION</h3> -->
              <a href="https://makemypass.com/event/demystifying-gamification-cracking-customer-engagement-in-a-distracted-world" target="_blank"
                class="btn btn-primary w-full text-white mb-2">Register Now</a>
            </div>
          </div>
          <!-- <ng-container *ngIf="!isFormShow && eventDetail?.status === 'up_coming'">
            <div class="register-form prose border mb-4 px-6 py-3"
              [ngClass]="currentTheme === 'dark' ? 'border-gray-500' : 'border-gray-300 '" *ngIf="!isEventEnd">
              <h3 class="text-center mb-3 py-3 ">Reserve your slot now</h3>
              <form [formGroup]="registerForm" [appSpinner]="isFormSaving" (ngSubmit)="onFormSubmit()"
                class="relative mb-5">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                  <div class="formgroup ">
                    <div class="label">
                      <span class="label-text text-slate-400 require">Name</span>
                    </div>
                    <input formControlName="name" type="text" placeholder="Enter your name"
                      class="input input-bordered w-full max-w-full lg:max-w-md" required />
                    <app-validation-errors [submitted]="invalidForm"
                      [control]="registerForm.get('name')"></app-validation-errors>
                  </div>
                  <div class="formgroup">
                    <div class="label">
                      <span class="label-text text-slate-400 require">Email</span>
                    </div>
                    <input type="email" formControlName="email" placeholder="Enter your email"
                      class="input input-bordered w-full max-w-full lg:max-w-xs" required />
                    <app-validation-errors [submitted]="invalidForm"
                      [control]="registerForm.get('email')"></app-validation-errors>
                    <app-server-validation-error [errors]="errors" key="detail"></app-server-validation-error>
                  </div>
                  <div class="formgroup">
                    <div class="label">
                      <span class="label-text text-slate-400">Job Title</span>
                    </div>
                    <input type="text" formControlName="job_title" placeholder="Enter your job title"
                      class="input input-bordered w-full max-w-full lg:max-w-xs" />
                  </div>
                  <div class="formgroup">
                    <div class="label">
                      <span class="label-text text-slate-400">Contact no</span>
                    </div>
                    <input type="text" formControlName="contact_phone" placeholder="Enter your contact no."
                      class="input input-bordered w-full max-w-full lg:max-w-xs" />
                  </div>
                  <div class="formgroup">
                    <div class="label">
                      <span class="label-text text-slate-400">Company/Organization</span>
                    </div>
                    <input type="text" formControlName="company" placeholder="Enter your company/organization"
                      class="input input-bordered w-full max-w-full lg:max-w-xs" />
                  </div>
                </div>
                <button type="submit" class="btn btn-primary w-full text-white mt-3">Register</button>
              </form>
            </div>
          </ng-container> -->

          <ng-container *ngIf="isSubmitted">
            <div class="bg-primary text-slate-50 p-10 text-center max-w-xl">
              <p>Your registration was successful! You will receive an email shortly.</p>
            </div>
          </ng-container>
        </div>
      </div>
    </section>
  </ng-template>
</div>
<dialog class="modal" #speakerModal>
  <div class="modal-box modal--box p-0 max-w-4xl rounded-2xl flex flex-col md:flex-row">
    <div class="flex-1 static md:sticky top-0 ">
      <div class="profile-pic">
        <img width="600" height="481" [src]="selectedSpeaker?.thumbs" (error)="onProfilePicError($event)"
          class="grayscale hover:grayscale-0 ease-linear duration-100" alt="{{selectedSpeaker?.speaker}}">
      </div>
      <div class="flex bg-primary p-4 justify-between items-center">
        <h3 class="font-bold text-2xl text-neutral">{{ selectedSpeaker?.name }}</h3>
        <div class="flex gap-3 text-neutral group [&_a:hover]:text-slate-50 [&_a]:ease-linear [&_a]:duration-100">
          <a *ngIf="selectedSpeaker?.facebook" target="_blank" href="{{selectedSpeaker?.facebook}}"><i
              class="fab fa-facebook-f text-xl"></i></a>
          <a *ngIf="selectedSpeaker?.twitter" target="_blank" href="{{selectedSpeaker?.twitter}}"><i
              class="fab fa-twitter text-xl"></i></a>
          <a *ngIf="selectedSpeaker?.linkedin" target="_blank" href="{{selectedSpeaker?.linkedIn}}"> <i
              class="fab fa-linkedin text-xl"></i></a>
          <a *ngIf="selectedSpeaker?.mail" target="_blank" href="mailto:{{selectedSpeaker?.mail}}">
            <i class="fas fa-paper-plane"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="px-10 flex-1">
      <div class="wrap-content pb-10 border-b-2">
        <h3 class="text-xl mb-3 mt-8 uppercase font-medium">About</h3>
        <p class="text-gray-500 text-sm">{{selectedSpeaker?.description}}</p>
      </div>
    </div>
    <div class="modal-action hidden md:block z-10">
      <form method="dialog" class="modal-backdrop">
        <button class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-2 top-2"
          (click)="speakerModal.close()">✕</button>
      </form>
    </div>
  </div>
  <div class="modal-action block md:hidden z-10 absolute -top-5 right-0">
    <form method="dialog" class="modal-backdrop">
      <button class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-2 top-2"
        (click)="speakerModal.close()">✕</button>
    </form>
  </div>
</dialog>
